const ENV = process.env.REACT_APP_ENV;

export {
  ENV
};
